import { render, staticRenderFns } from "./playButton.vue?vue&type=template&id=2d4b56c6&scoped=true&"
var script = {}
import style0 from "./playButton.vue?vue&type=style&index=0&id=2d4b56c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b56c6",
  null
  
)

export default component.exports